import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})

/**
 * Team component
 */
export class TeamComponent implements OnInit {

  constructor(public modal:NgbModal) { }

  ngOnInit(): void {
  }

}
